import { Outlet } from "react-router-dom";
import Offline from '../components/Offline';
import { useEffect, useState } from "react";
import Header from "../components/Header";
import { getCityList, getOtgList } from "../Axios/searchoff";
// import Footer from "../components/Footer";
// import { getMenuList } from "../Axios/pages";
import { selectOptions } from '../utils/search';

const Layout = () => {

    const [online, setOnline] = useState(false);
    //Стани для пошуку вимкень
    const [cityOptions, setCityOptions] = useState([]);
    const [otgOptions, setOtgOptions] = useState([]);

    if(window.navigator.onLine){
        if(!online)
            setOnline(true);
    }else {
        if(online)
            setOnline(false);
    }
    window.addEventListener('online', () => {
        if(!online)
            setOnline(true);
    });
    window.addEventListener('offline', () => {
        if(online)
            setOnline(false);
    });

    // при першій відгрузці сторінки витягуєм перелік ОТГ + Міста
    useEffect(()=>{
        selectOptions(getCityList, setCityOptions);
        selectOptions(getOtgList, setOtgOptions);
    },[]);


    return (
        <>
            <Header/>
            {(!online)? <Offline />: ''}
            <Outlet context={{otgOptions, cityOptions, setCityOptions}} />
            {/* <Footer/> */}
        </>
    )
};

export default Layout;

